// 静态路由配置
// 书写格式与动态路由格式一致，全部经由框架统一转换
// 比较动态路由在meta中多加入了role角色权限，为数组类型。一个菜单是否有权限显示，取决于它以及后代菜单是否有权限。
// routes 显示在左侧菜单中的路由(显示顺序在动态路由之前)
// 示例如下

const routes = [


    {
        name: "products",
        path: "/products",
        meta: {
            title: "产品",
            icon: "el-icon-goods-filled",
            permissions: ['ProductManagement']
        },
        children: [
            {
                name: "brands",
                path: "/products/brands",
                meta: {
                    title: "品牌信息",
                    // icon: "el-icon-wind-power",
                    permissions: ['ProductManagement.BrandManagement']
                },
                component: "products/brands"
            },
            {
                name: "categories",
                path: "/products/categories",
                meta: {
                    title: "分类信息",
                    // icon: "el-icon-grid",
                    permissions: ['ProductManagement.CategoryManagement']
                },
                component: "products/categories"
            },
            {
                name: "specialAttributes",
                path: "/products/specialAttributes",
                meta: {
                    title: "特殊属性",
                    // icon: "el-icon-help",
                    permissions: ['ProductManagement.SpecialManagement']
                },
                component: "products/specialAttributes"
            },
            {
                name: "products",
                path: "/products/products",
                meta: {
                    title: "产品信息",
                    // icon: "el-icon-goods-filled",
                    permissions: ['ProductManagement.ProductInfo']
                },
                component: "products/products"
            },
        ]
    },
    {
        name: "sales",
        path: "/sales",
        meta: {
            title: "销售",
            icon: "el-icon-goods",
            permissions: ['SalesManagement']
        },
        children: [
            {
                name: "AddGoods",
                path: "/sales/addListing",
                meta: {
                    title: "新增Listing",
                    // icon: "el-icon-goods",
                    permissions: ['SalesManagement.AddListing']
                },
                component: "products/goods/components/AddGoods.vue"
            },
            {
                name: "EditGoods",
                path: "/sales/editListing",
                meta: {
                    title: "编辑Listing",
                    // icon: "el-icon-goods",
                    hidden: true,
                },
                component: "products/goods/components/EditGoods.vue"
            },
            {
                name: "SeeGoods",
                path: "/sales/seeListing",
                meta: {
                    title: "查看Listing",
                    // icon: "el-icon-goods",
                    hidden: true,
                },
                component: "products/goods/components/SeeGoods.vue"
            },
            {
                name: "vcgoods",
                path: "/sales/listing",
                meta: {
                    title: "Listing管理",
                    // icon: "el-icon-goods",
                    permissions: ['SalesManagement.ListingManagement']
                },
                component: "products/goods"
            },
        ]
    },
    {
        name: "orders",
        path: "/orders",
        meta: {
            title: "订单",
            icon: "el-icon-shopping-cart-full",
            permissions: ['OrderManagement']
        },
        children: [
            {
                groupName: 'DF订单',
                name: "dforders",
                path: "/orders/dfOrders",
                meta: {
                    title: "DF订单",
                    // icon: "el-icon-shopping-cart",
                    permissions: ['OrderManagement.DFOrderManagement']
                },
                component: "orders/dfOrders"
            },
            {
                groupName: 'PO订单',
                name: "poOrders",
                path: "/orders/poOrders",
                meta: {
                    title: "PO订单",
                    // icon: "el-icon-shopping-cart-full",
                    permissions: ['OrderManagement.POOrderManagement']
                },
                component: "orders/poOrders"
            },
            {
                groupName: 'PO订单',
                name: "orderShipment",
                path: "/orders/orderShipment",
                meta: {
                    title: "订单货件",
                    // icon: "el-icon-shopping-cart-full",
                    permissions: ['OrderManagement.OrderShipment']
                },
                component: "orders/orderShipment"
            },
            {
                groupName: 'PO订单',
                name: "createShipment",
                path: "/orders/createShipment/:id",
                meta: {
                    title: "创建货件",
                    // icon: "el-icon-list",
                    hidden: true,
                    permissions: ['OrderManagement.OrderShipment.CreateShipment']
                },
                component: "orders/orderShipment/components/createShipment",
                children: []
            },
            {
                groupName: 'DF订单',
                name: "orderProcessing",
                path: "/orders/orderProcessing",
                meta: {
                    title: "订单处理",
                    // icon: "el-icon-shopping-cart-full",
                    permissions: ['OrderManagement.OrderProcessing']
                },
                component: "orders/orderProcessing"
            },
            {
                groupName: 'DF订单',
                name: "orderRule",
                path: "/orders/orderRules",
                meta: {
                    title: "订单规则",
                    // icon: "el-icon-shopping-cart-full",
                    permissions: ['OrderManagement.OrderRule']
                },
                component: "orders/orderRules"
            },
            {
                groupName: '业务设置',
                name: "amazonStock",
                path: "/vcSetting/amazonStock",
                meta: {
                    title: "DF库存管理",
                    // icon: "el-icon-shopping-cart-full",
                    permissions: ['OrderManagement.DfStock']
                },
                component: "vcSetting/amazonStock"
            },
            // {
            //     groupName: '业务设置',
            //     name: "amazonStockAutoSyncList",
            //     path: "/vcSetting/amazonStockAutoSyncList",
            //     meta: {
            //         title: "自动同步列表",
            //         // icon: "el-icon-shopping-cart-full",
            //         permissions: ['OrderManagement.DfStock']
            //     },
            //     component: "vcSetting/amazonStockAutoSyncList"
            // },
        ]
    },
    {
        name: "marketing",
        path: "/marketing",
        meta: {
            title: "促销",
            icon: "el-icon-discount",
            permissions: ['MarketingManagement']
        },
        children: [
            {
                name: "coupons",
                path: "/marketing/coupons",
                meta: {
                    title: "优惠券",
                    // icon: "el-icon-money",
                    permissions: ['MarketingManagement.CouponManagement']
                },
                component: "marketing/coupons",
                children: []
            },
            {
                name: "bestDeals",
                path: "/marketing/bestDeals",
                meta: {
                    title: "秒杀活动",
                    // icon: "el-icon-timer",
                    permissions: ['MarketingManagement.SeckillManagement']
                },
                component: "marketing/bestDeals",
                children: []
            },
            {
                name: "priceDiscount",
                path: "/marketing/priceDiscount",
                meta: {
                    title: "PriceDiscount",
                    // icon: "el-icon-timer",
                    permissions: ['MarketingManagement.PriceDiscountManagement.Query']
                },
                component: "marketing/priceDiscount",
                children: []
            },
        ]
    },
    {
        name: "warehousing",
        path: "/warehousing",
        meta: {
            title: "仓储",
            icon: "el-icon-box",
            permissions: ['WarehouseManagement']
        },
        children: [
            {
                name: "warehousingWarehouse",
                path: "/warehousing/warehouse",
                meta: {
                    title: "仓库列表",
                    // icon: "el-icon-list",
                    permissions: ['WarehouseManagement.WarehouseList']
                },
                component: "warehousing/warehouse",
                children: []
            },
            {
                name: "wareHouseProductInventory",
                path: "/warehousing/productinventory",
                meta: {
                    title: "产品库存",
                    // icon: "el-icon-goods-filled",
                    permissions: ['WarehouseManagement.ProductInventory']
                },
                component: "warehousing/productInventory",
                children: []
            },
            {
                name: "warehouseInventory",
                path: "/warehousing/warehouseinventory",
                meta: {
                    title: "仓库库存",
                    // icon: "el-icon-shop",
                    permissions: ['WarehouseManagement.WarehouseInventory']
                },
                component: "warehousing/wareHouseInventory",
                children: []
            },
            {
                name: "amazonWareHouse",
                path: "/warehousing/amazonWareHouse",
                meta: {
                    title: "亚马逊仓库配置",
                    // icon: "el-icon-shop",
                    permissions: ['WarehouseManagement.AmazonWareHouse']
                },
                component: "warehousing/amazonWareHouse",
                children: []
            },
        ]
    },
    {
        name: "logisticsWarehousing",
        path: "/logistics",
        meta: {
            title: "物流",
            icon: "el-icon-van",
            permissions: ['logistics']
        },
        children: [
            {
                name: "logisticsWarehousing",
                path: "/logistics",
                meta: {
                    title: "海外仓物流",
                    // icon: "el-icon-list",
                    permissions: ['WarehouseManagement.WarehouseList']
                },
                component: "logistics/",
                children: []
            }
        ]
    },
    {
        name: "statistics",
        path: "/statistics",
        meta: {
            title: "统计",
            icon: "el-icon-histogram",
            permissions: ['StatisticsManagement']
        },
        children: [
            {
                groupName: 'VC统计',
                name: "vcSalesStatistics",
                path: "/statistics/vc/vcSalesStatistics",
                meta: {
                    title: "VC销量统计",
                    // icon: "el-icon-list",
                    permissions: ['StatisticsManagement.VCSalesStatistics']
                },
                component: "statistics/vc/vcSalesStatistics",
                children: []
            },
            {
                groupName: 'VC统计',
                name: "vcVcInventoryStatistics",
                path: "/statistics/vc/vcInventoryStatistics",
                meta: {
                    title: "VC库存统计",
                    // icon: "el-icon-list",
                    permissions: ['StatisticsManagement.VCInventoryStatistics']
                },
                component: "statistics/vc/vcInventoryStatistics",
                children: []
            },
            {
                groupName: '采购统计',
                name: "dfStatistics",
                path: "/statistics/purchase",
                meta: {
                    title: "DF采购统计",
                    // icon: "el-icon-list",
                    permissions: ['StatisticsManagement.DFPurchaseStatistics']
                },
                component: "statistics/purchase/dfStatistics",
                children: []
            }
        ]
    },
    {
        name: "amazoncase",
        path: "/amazoncase",
        meta: {
            title: "工单",
            icon: "el-icon-service",
            permissions: ['CaseManagement']
        },
        children: [
            {
                name: "amazoncase",
                path: "/case/amazon",
                meta: {
                    title: "亚马逊工单",
                    // icon: "el-icon-list",
                    permissions: ['CaseManagement.AmazonCase']
                },
                component: "case/amazon",
                children: []
            },
            {
                name: "casedetail",
                path: "/case/detail/:id",
                meta: {
                    title: "亚马逊工单详情",
                    // icon: "el-icon-list",
                    hidden: true,
                    permissions: ['CaseManagement.AmazonCase']

                },
                component: "case/amazon/detail",
                children: []
            },
        ]
    },
    {
        name: "finance",
        path: "/finance",
        meta: {
            title: "财务",
            icon: "el-icon-wallet",
            permissions: ['FinanceManagement']
        },
        children: [
            {
                groupName: '收入',
                name: "dfInvoice",
                path: "/finance/dfInvoice",
                meta: {
                    title: "DF发票",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.DfInvoice']
                },
                component: "finance/dfInvoice",
                children: []
            },
            {
                groupName: '收入',
                name: "poInvoice",
                path: "/finance/poInvoice",
                meta: {
                    title: "PO发票",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.PoInvoice']
                },
                component: "finance/poInvoice",
                children: []
            },
            {
                groupName: '费用',
                name: "coOpSalesDiscount",
                path: "/finance/coOpSalesDiscount",
                meta: {
                    title: "销售折扣费用",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.CoOpSalesDiscount']
                },
                component: "finance/coOpSalesDiscount",
                children: []
            },
            {
                groupName: '费用',
                name: "coOpAccrual",
                path: "/finance/coOpAccrual",
                meta: {
                    title: "营销应计费用",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.CoOpAccrual']
                },
                component: "finance/coOpAccrual",
                children: []
            },
            {
                groupName: '费用',
                name: "coOpAccrual0123",
                path: "/finance/coOpAccrual0123",
                meta: {
                    title: "PO收款费用",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.CoOpAccrual']
                },
                component: "finance/coOpAccrual0123",
                children: []
            },
            {
                groupName: '费用',
                name: "coOpAccrual123",
                path: "/finance/coOpAccrual123",
                meta: {
                    title: "C2FO收款费用",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.CoOpAccrual']
                },
                component: "finance/coOpAccrual123",
                children: []
            },
            {
                groupName: '费用',
                name: "coOpAccrual1234",
                path: "/finance/coOpAccrual1234",
                meta: {
                    title: "Chargebacks",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.CoOpAccrual']
                },
                component: "finance/coOpAccrual1234",
                children: []
            },
            {
                groupName: '财务结算',
                name: "coOpAccrual123",
                path: "/finance/coOpAccrual123",
                meta: {
                    title: "结算中心",
                    // icon: "el-icon-list",
                    permissions: ['FinanceManagement.CoOpAccrual']
                },
                component: "finance/coOpAccrual123",
                children: []
            }
        ]
    },
    {
        name: "setting",
        path: "/setting",
        meta: {
            title: "设置",
            icon: "el-icon-help",
            permissions: ['AbpIdentity']
        },
        children: [
            {
                name: "user",
                path: "/setting/user",
                meta: {
                    title: "用户管理",
                    // icon: "el-icon-user-filled",
                    permissions: ['AbpIdentity.Users']
                },
                component: "setting/user"
            },
            {
                name: "role",
                path: "/setting/role",
                meta: {
                    title: "角色管理",
                    // icon: "el-icon-notebook",
                    permissions: ['AbpIdentity.Roles']
                },
                component: "setting/role"
            },
            {
                name: "system",
                path: "/setting/system",
                meta: {
                    title: "系统设置",
                    //icon: "el-icon-tools",
                    permissions: ['SettingManagement']
                },
                component: "setting/system"
            },
            {
                name: "shop",
                path: "/shops/shops",
                meta: {
                    title: "店铺管理",
                    // icon: "el-icon-shop",
                    permissions: ['AbpIdentity.ShopManagement']
                },
                component: "shops/shops"
            },
            {
                name: "shopVCCode",
                path: "/shops/vcCodes",
                meta: {
                    title: "VCCode",
                    // icon: "el-icon-platform",
                    permissions: ['AbpIdentity.VCCodeManagement']
                },
                component: "shops/vcCodes"
            },
            {
                name: "plugins",
                path: "/shops/plugin",
                meta: {
                    title: "插件助手",
                    // icon: "el-icon-platform",
                    permissions: ['AbpIdentity.PluginManagement.Query']
                },
                component: "shops/plugin"
            },
            {
                name: "companys",
                path: "/setting/company",
                meta: {
                    title: "公司管理",
                    permissions: ['AbpIdentity.CompanyManagement']
                },
                component: "setting/company"
            }
        ]
    },
    {
        name: "home",
        path: "/home",
        meta: {
            title: "首页",
            icon: "el-icon-home-filled",
            hidden: true,
        },
        children: [
            {
                name: "dashboard",
                path: "/dashboard",
                component: "home",
                meta: {
                    // icon: "el-icon-menu",
                    title: "首页",
                    affix: true
                }
            },
            {
                name: "userCenter",
                path: "/userCenter",
                component: "userCenter",
                meta: {
                    // icon: "el-icon-user",
                    title: "帐号信息"

                }
            }
        ]
    },
]

// const routes = []

export default routes;
